import React, { useRef, useEffect } from "react";

const TeleprompterLyrics = ({
  lines = [],
  currentLineIndex = -1,
  fontSize = 36,
}) => {
  const containerRef = useRef(null);
  const lineRefs = useRef([]);

  // Smooth scroll to current line (centered vertically)
  useEffect(() => {
    if (
      currentLineIndex < 0 ||
      !lineRefs.current[currentLineIndex] ||
      !containerRef.current
    )
      return;

    const lineEl = lineRefs.current[currentLineIndex];
    const container = containerRef.current;
    const targetScroll =
      lineEl.offsetTop - container.clientHeight / 2 + lineEl.clientHeight / 2;

    container.scrollTo({
      top: Math.max(0, targetScroll),
      behavior: "smooth",
    });
  }, [currentLineIndex]);

  return (
    <div
      ref={containerRef}
      className="overflow-y-auto px-6 md:px-16 py-16"
      style={{
        flex: "1 1 0%",
        minHeight: 0,
        touchAction: "pan-y",
        scrollBehavior: "auto",
      }}
    >
      {lines.map((line, i) => (
        <div
          key={i}
          ref={(el) => {
            lineRefs.current[i] = el;
          }}
          className={`transition-all duration-300 py-2 text-center ${
            i === currentLineIndex
              ? "text-gold-500 scale-105 font-semibold"
              : i < currentLineIndex
                ? "text-forest-600 opacity-40"
                : "text-forest-200"
          }`}
          style={{
            fontSize: i === currentLineIndex ? fontSize * 1.1 : fontSize,
            lineHeight: 1.4,
          }}
        >
          {line || "\u00A0"}
        </div>
      ))}
      {/* Bottom padding so last lines can scroll to center */}
      <div style={{ height: "50vh" }} />
    </div>
  );
};

export default TeleprompterLyrics;
